import { Stack } from '@mui/material';
import { TargetSevices } from '../../../Apis/TargetSevices';
import { ApproveIcon } from '../../../components/Icons/Icons';
import LmDialog from '../../../components/common/LmDialog';
import VegaButton from '../../../components/common/VegaButton';
import VegaDialogContent from '../../../components/common/VegaDialogContent';
import VegaText from '../../../components/common/VegaText';
import { GREY } from '../../../constants/style';
import {
  getTargetList,
  getTargetState,
  setOpenReRaiseTargetDialog,
} from '../../../features/targetSlice';
import { useClientAuth } from '../../../providers/ClientProvider';
import { useSnackbar } from '../../../providers/SnackbarProvider';
import { useAppDispatch, useAppSelector } from '../../../store';
import { TargetsStatus } from '../../../types/targets';
import { getErrorMessageFromErrorObj } from '../../../utils/api';

const ReRaiseTargetDialog = () => {
  const { user } = useClientAuth();
  const { openReRaiseTargetDialog, bucketDetails } =
    useAppSelector(getTargetState);
  const dispatch = useAppDispatch();
  const { setSnackbar } = useSnackbar();

  const onClose = () => {
    dispatch(setOpenReRaiseTargetDialog(false));
  };
  const onRaiseTarget = () => {
    TargetSevices.updateTargetStatus({
      id: bucketDetails.id,
      newStatus: TargetsStatus.RE_RAISE,
    })
      .then(() => {
        setSnackbar('Approve Successfully !!!');
        dispatch(
          getTargetList({
            approverId: user?.id,
            listOfTargetStatus: [TargetsStatus.RAISED],
          })
        );
        onClose();
      })
      .catch(error => {
        setSnackbar(getErrorMessageFromErrorObj(error), 'error');
      });
  };
  return (
    <>
      <LmDialog
        fullWidth
        maxWidth="xs"
        open={openReRaiseTargetDialog}
        handleClose={onClose}
        buttonComponent={() => (
          <>
            <Stack
              width={'100%'}
              direction={'row'}
              alignItems={'center'}
              px={4}
              pb={4}
              gap={1}
            >
              <VegaButton
                text="Cancel"
                fullWidth
                variant="outlined"
                sx={{
                  color: GREY.dark,
                  borderColor: GREY.dark,
                  ':hover': {
                    color: GREY.dark,
                    bgcolor: 'transparent',
                    borderColor: GREY.dark,
                  },
                }}
                onClick={onClose}
              />
              <VegaButton
                fullWidth
                text="Re-Raise"
                startIcon={<ApproveIcon strokeColor="white" />}
                onClick={onRaiseTarget}
              />
            </Stack>
          </>
        )}
        headerComponent={() => (
          <Stack
            direction={'row'}
            alignItems={'center'}
            px={4}
            py={2.5}
            gap={2}
            bgcolor={'#E5F7FC'}
          >
            <VegaText
              text="Are you sure?"
              fontWeight={600}
              fontSize={'1.0625rem'}
              color={'black'}
            />
          </Stack>
        )}
      >
        <VegaDialogContent>
          <VegaText
            text={`You want to re- raise this Target?`}
            fontWeight={600}
            fontSize={'1.0625rem'}
            color={'black'}
          />
        </VegaDialogContent>
      </LmDialog>
    </>
  );
};

export default ReRaiseTargetDialog;
